"use client";

import { createContext, useContext, useState, type ReactNode } from "react";

type AuthModalContextType = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

const AuthModalContext = createContext<AuthModalContextType>({
  open: false,
  setOpen: () => {},
});

const AuthModalProvider = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false);

  return (
    <AuthModalContext.Provider value={{ open, setOpen }}>
      {children}
    </AuthModalContext.Provider>
  );
};

const useAuthModal = () => useContext(AuthModalContext);

export { AuthModalProvider, useAuthModal };
